import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Giphy} from '../../models/giphy';

@Injectable({
  providedIn: 'root'
})
export class GiphyClient {
  private apiKey = 'FdznS3vjrcfHfRyERWcBbMvQgy4CxnBp';

  public endpoint = 'https://api.giphy.com/v1/gifs/search';

  public constructor(public http: HttpClient) {
  }

  public search(query: string): Promise<Giphy[]> {
    return new Promise<Giphy[]>((resolve) => {
      this.http.get(this.endpoint, {
        params: {
          api_key: this.apiKey,
          q: query,
          limit: '100',
          offset: '0',
          lang: 'nl',
          rating: 'PG'
        }
      }).subscribe((response: any) => {
        resolve(response.data.map(entry => {
          return <Giphy>{url: entry.images.fixed_height.url};
        }));
      });
    });
  }
}
